var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "_component-icon-plus",
      style: _vm.componentStyle,
      attrs: { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M11 2V9H18V11H10.999L11 18H9L8.999 11H2V9H9V2H11Z",
          fill: "#17181A"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }